import { styled, Button, Box, IconButton, ButtonBase } from '@mui/material'
import theme from 'lib/theme'

export const SidebarBtn = styled(Button, {
  shouldForwardProp: (props) => props !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  height: '40px',
  borderRadius: '2px',
  padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
  marginTop: theme.spacing(1),
  marginRight: 0,
  marginLeft: 0,
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  color: theme.palette.commonColors.black,
  '&:hover': {
    backgroundColor: selected
      ? theme.palette.action.selected
      : theme.palette.action.hover,
    cursor: 'pointer',
  },
}))

export const DatePickerButton = styled(Button, {
  shouldForwardProp: (props) => props !== 'width',
})<{ width?: string }>(({ width }) => ({
  height: '44px',
  fontSize: '16px',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.neutral.grey9,
  color: theme.palette.commonColors.black,
  textAlign: 'left',
  width: width || '220px',
  fontWeight: 400,
  justifyContent: 'space-between',
  border: 'none',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.neutral.grey8,
    border: 'none',
  },
}))

export const MapBtnWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'visible',
})<{ visible: string }>(({ visible }) => ({
  position: 'absolute',
  zIndex: 1000,
  top: '60px',
  display: visible,
}))

export const MapBtn = styled(IconButton, {
  shouldForwardProp: (props) => props !== 'marginLeft',
})<{ marginLeft: string }>(({ marginLeft }) => ({
  borderRadius: '50%',
  marginLeft,
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.icon.main,
  '&:hover': {
    backgroundColor: theme.palette.icon.hover,
  },
}))

export const DeliveryAreaGroupBtn = styled(ButtonBase, {
  shouldForwardProp: (props) => props !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(7),
  justifyContent: 'flex-start',
  width: '100%',
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  '&:hover': {
    backgroundColor: selected
      ? theme.palette.action.selected
      : theme.palette.action.hover,
    cursor: 'pointer',
  },
}))
